<template>
    <div class="content">
        <!-- TODO:考试页面HTML -->
        <Card class="main" v-if="showTest">
            <Row type="flex" justify="end">
                <div style="color: #3562e8; margin-bottom: 15px; cursor: pointer" @click="examEnd">退出考试</div>
                <div class="anwserBox">
                    <Row>
                        <Col :span="16">
                            <div class="titleBox">
                                <Row>
                                    <Col :span="15">
                                        <h3>{{ course }}课程答题测试</h3>
                                    </Col>
                                    <Col :span="9" style="text-align: right">
                                        <span>第{{ current + 1 }}题</span>
                                        <span>共{{ answerSize }}题</span>
                                        <img class="spanImg" src="https://medoss.oss-cn-shanghai.aliyuncs.com/uploads/1621582606030.png" />
                                    </Col>
                                </Row>
                                <div class="content">
                                    <div v-if="allData[this.current].type == 1">
                                        <div class="question">
                                            <h1>{{ question }}</h1>
                                        </div>
                                        <div>
                                            <div style="text-align: left">
                                                <RadioGroup v-model="answer">
                                                    <!-- <Radio :disabled="TestCompleted" :class="[TestCompleted && item.name == allData[current].userAnswer ? 'answerAffirm':'', item.name == allData[current].userAnswer && TestCompleted?'errDatas':'']" 
                          v-for="(item, i) in allData[this.current].options" :key="i" :label="item.name" >
                          {{ item.name }}.{{ item.option }} {{ TestCompleted }} {{ allData[current].answer }} {{ allData[current].userAnswer }}
                        </Radio> -->
                                                    <Radio
                                                        :disabled="TestCompleted"
                                                        :class="[
                                                            TestCompleted && item.name == allData[current].userAnswer
                                                                ? allData[current].userAnswer == allData[current].answer
                                                                    ? 'answerAffirm'
                                                                    : 'errDatas'
                                                                : '',
                                                        ]"
                                                        v-for="(item, i) in allData[this.current].options"
                                                        :key="i"
                                                        :label="item.name">
                                                        {{ item.name }}.{{ item.option }}
                                                    </Radio>
                                                </RadioGroup>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="allData[this.current].type == 2">
                                        <div class="question">
                                            <h1>{{ question }}</h1>
                                        </div>
                                        <div>
                                            <div style="text-align: left">
                                                <CheckboxGroup v-model="answers">
                                                    <Checkbox
                                                        :disabled="TestCompleted"
                                                        v-for="(item, i) in allData[this.current].options"
                                                        :key="i"
                                                        :class="[
                                                            TestCompleted && item.isAnswer == 1 ? 'errorAnswer' : '',
                                                            TestCompleted && item.isCorrect && item.isAnswer == 1 ? 'answerAffirm' : '',
                                                        ]"
                                                        :label="item.name">
                                                        {{ item.name }}.{{ item.option }}
                                                    </Checkbox>
                                                </CheckboxGroup>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="allData[this.current].type == 3">
                                        <div class="question">
                                            <h1>{{ question }}</h1>
                                        </div>
                                        <div>
                                            <div style="text-align: left">
                                                <Input v-model="anwserString" type="textarea" :rows="9" placeholder="请输入答案" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="buttonBox">
                                        <Button type="primary" style="width: 188px; height: 52px; background: #3458c4; border: none" @click="pre"
                                            >上一题</Button
                                        >
                                        <Button
                                            v-if="current != allData.length - 1"
                                            type="primary"
                                            style="width: 188px; height: 52px; background: #3458c4; border: none; margin-left: 36px"
                                            @click="next"
                                            >下一题</Button
                                        >
                                        <Button
                                            v-if="current == allData.length - 1 && !TestCompleted"
                                            type="primary"
                                            style="width: 188px; height: 52px; background: #3458c4; border: none; margin-left: 36px"
                                            @click="subTopic"
                                            >提交试卷</Button
                                        >
                                        <Button
                                            v-if="current == allData.length - 1 && TestCompleted"
                                            type="primary"
                                            style="width: 188px; height: 52px; background: #3458c4; border: none; margin-left: 36px"
                                            @click="$router.push('/courseList')"
                                            >返回课程</Button
                                        >
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col :span="8">
                            <div>
                                <div class="right">
                                    <div class="title">答题时间</div>
                                    <div
                                        v-if="showAnsTime"
                                        style="font-size: 36px; font-weight: bold; color: #3562e8; letter-spacing: 5px; margin-bottom: 22px">
                                        {{ h + ":" + m + ":" + s }}
                                    </div>
                                    <div
                                        v-if="!showAnsTime"
                                        style="font-size: 36px; font-weight: bold; color: #3562e8; letter-spacing: 5px; margin-bottom: 22px">
                                        答题已结束!
                                    </div>
                                    <Button class="submit" :disabled="subBtn" @click="subTopic">提交试卷</Button>
                                    <div class="title" style="margin-top: 37px">答题卡</div>
                                    <div>单选题</div>
                                    <div class="singleBox">
                                        <div
                                            :class="[
                                                item.id == allData[current].id || item.isOK ? 'optionsActive' : 'options',
                                                item.userAnswer ? 'userActive' : '',
                                                item.answer === item.userAnswer ? '' : '',
                                                showQuestionBank && item.answer === item.userAnswer ? 'answerGreen' : '',
                                                showQuestionBank && item.userAnswer && item.answer !== item.userAnswer ? 'answerRed' : '',
                                            ]"
                                            v-for="(item, i) in single"
                                            :key="i">
                                            {{ i + 1 }}
                                        </div>
                                    </div>
                                    <div style="margin-top: 34px">多选题</div>
                                    <div class="multipleBox">
                                        <div
                                            :class="[
                                                item.id == allData[current].id || item.isOK ? 'optionsActive' : 'options',
                                                item.userAnswer ? 'userActive' : '',
                                                item.answer === item.userAnswer ? '' : '',
                                                showQuestionBank && item.answer == item.userAnswer ? 'answerGreen' : '',
                                                showQuestionBank && item.answer !== item.userAnswer ? 'answerRed' : '',
                                            ]"
                                            v-for="(item, i) in multiple"
                                            :key="i">
                                            {{ i + single.length + 1 }}
                                        </div>
                                    </div>
                                    <div style="margin-top: 34px">简答题</div>
                                    <div class="shortBox">
                                        <div
                                            :class="[
                                                item.id == allData[current].id || item.isOK ? 'optionsActive' : 'options',
                                                item.userAnswer ? 'userActive' : '',
                                                item.answer === item.userAnswer ? '' : '',
                                                showQuestionBank && item.answer === item.userAnswer ? 'answerGreen' : '',
                                                showQuestionBank && item.answer !== item.userAnswer ? 'answerRed' : '',
                                            ]"
                                            v-for="(item, i) in short"
                                            :key="i">
                                            {{ i + single.length + multiple.length + 1 }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Row>
        </Card>
        <!-- TODO:最开始进入页面显示考试题信息 -->
        <Card class="create" v-if="showStart">
            <h2>{{ course }}课程答题测试</h2>
            <div class="courseInfo">
                <div>答题总数:{{ answerSize }}题</div>
                <div>及格题数:{{ passNumber }}题</div>
                <div>答题时限:{{ answerTime }}分钟</div>
                <div v-show="passAlso > 1">剩余答题次数:{{ passAlso }}次</div>
            </div>
            <div>
                <Button type="primary" @click="startTest">开始答题</Button>
                <Button type="primary" ghost @click="$router.push('index')" style="margin-left: 20px">返回首页</Button>
            </div>
        </Card>
        <!-- TODO：成功页面HTML -->
        <Card class="success" v-if="result == 1">
            <h2>{{ course }}课程答题测试</h2>
            <img src="../../../assets/img/common/success.png" alt="" />
            <div class="testSuccess">
                <h3 style="display: inline; margin-right: 30px">考试通过!</h3>
                <Button type="primary" ghost style="widht: 111px; height: 33px; border-radius: 17px" @click="successLook">查看试卷</Button>
            </div>
            <div style="font-size: 16px; font-weight: bold; margin-top: 50px">
                交卷时间:{{ subTime }} &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; 考试用时:{{ duration }}
            </div>
            <div style="height: 1px; width: 800px; background: #ebebeb; margin: 30px auto"></div>
            <div style="font-size: 16px; font-weight: bold">
                题目总数:{{ answerSize }}题 &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; 答题总数:{{ right.length + err.length }}题
            </div>
            <div style="font-size: 16px; font-weight: bold; margin-top: 30px">
                答对题数:{{ right.length }}题 &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; 答错题数:{{ err.length }}题
            </div>
            <div style="margin-top: 85px">
                <Button type="primary" @click="$router.push('/courseList')">返回课程</Button>
                <Button type="primary" style="margin-left: 20px" ghost @click="$router.push('/index')">返回首页</Button>
            </div>
        </Card>
        <!-- TODO:等待批阅HTML -->
        <Card class="wait" v-if="result == 3">
            <h2>{{ course }}课程答题测试</h2>
            <img src="../../../assets/img/common/wait.png" alt="" />
            <div>
                <h3>考试完成,等待批阅</h3>
            </div>
            <div style="font-size: 16px; font-weight: bold; margin-top: 40px">题目总数:{{ answerSize }}题</div>
            <div style="margin-top: 130px">
                <Button type="primary" @click="$router.push('/courseList')">返回课程</Button>
                <Button type="primary" ghost style="margin-left: 20px" @click="$router.push('/index')">返回首页</Button>
            </div>
        </Card>
        <!-- TODO:失败页面HTML -->
        <Card class="error" v-if="result == 2">
            <h2>{{ course }}课程答题测试</h2>
            <img src="../../../assets/img/common/error.png" alt="" />
            <h3>考试未通过!</h3>
            <div style="margin: 20px 0 45px 0">
                <Button type="primary" ghost style="width: 111px; height: 33px; border-radius: 17px" @click="successLook">查看试卷</Button>
                <Button type="success" ghost style="width: 111px; height: 33px; border-radius: 17px; margin-left: 35px" @click="reload"
                    >重新测试</Button
                >
            </div>
            <div style="font-size: 16px; font-weight: bold">
                交卷时间:{{ subTime }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 考试用时:{{ duration }}
            </div>
            <div style="width: 800px; height: 1px; margin: 35px auto; background: #ebebeb"></div>
            <div style="font-size: 16px; font-weight: bold">答题总数:{{ err.length + right.length }}题</div>
            <div style="font-size: 16px; font-weight: bold; margin-top: 30px">
                答对题数:{{ right.length }}题&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;答错题数:{{ err.length }}题
            </div>
            <div style="margin-top: 85px">
                <Button type="primary" @click="$router.push('/courseList')">返回课程</Button>
                <Button type="primary" ghost style="margin-left: 20px" @click="$router.push('/index')">返回首页</Button>
            </div>
        </Card>
    </div>
</template>

<script>
import { queryCloseExam, queryExamList, saveTopic, startExam, endExam } from "@/network/class.js";
import { minutes } from "@/common/utils.js";

import { mapMutations } from "vuex";
import Cookies from "js-cookie";

export default {
    name: "openClass",
    data() {
        return {
            //开始时间
            startTime: "",
            //结束时间
            successTime: "",
            //交卷时间
            subTime: "",
            //答题耗时
            duration: "",
            question: "",
            //单选题
            answer: "",
            //多选题
            answers: [],
            //简答题
            //显示答题页面
            showStart: true,
            showTest: false,
            anwserString: "",
            multiple: [],
            single: [],
            short: [],
            end: null,
            timmer: null,
            now: null,
            cha: null,
            h: null,
            m: null,
            subBtn: false,
            s: null,
            //总题数
            answerSize: "",
            //标题名
            course: "",
            //每一项的下标
            current: 0,
            //通过数量
            passNumber: "",
            //答题限时
            answerTime: "",
            //剩余次数
            passAlso: "",
            //答一题存一题的info
            saveInfo: {
                examId: null,
                questionId: null,
                userAnswer: null,
            },
            //题的类型 1 单选 2 多选 3 简答
            type: null,
            //   所有题
            allData: [],
            result: null, //1成功  2失败  3待审批,
            right: "",
            err: "",
            showAnsTime: true, //显示答题倒计时
            showQuestionBank: false,
            TestCompleted: false, //考试完成
            gameOver: null,
        };
    },
    mounted() {
        this.data = JSON.parse(this.$route.query.row);
        console.log(this.data);
        this.course = this.data.courseName;
        this.getData({
            courseId: this.data.courseId,
            projectId: this.data.projectId,
        });
        this.h = "00";
        this.m = "00";
        this.s = "00";
        this.allData = [];
        this.getExam();
    },
    //页面销毁的生命周期
    destroyed() {
        let p = localStorage.getItem("projectData");
        let i = JSON.parse(p);
        if (!this.TestCompleted) {
            endExam({
                courseId: this.data.courseId,
                examId: this.saveInfo.examId,
                projectId: this.data.projectId,
                orderNo: i.orderNo,
                list: [],
            }).then((res) => {
                console.log(res);
                if (res.data.code == 200) {
                    console.log("object :>> ", "中途结束考试");
                }
            });
            this.$Message["info"]({
                background: true,
                content: "退出考试成功",
                duration: 3,
            });
        }
        this.$store.commit("asHead", true);
        this.current = 0;
        this.end = null;
        this.h = null;
        this.m = null;
        this.s = null;
        clearInterval(this.timmer);
    },
    methods: {
        ...mapMutations(["AS_HEAD"]),
        //成功之后查看试卷
        successLook() {
            this.showTest = true;
            this.result = null;
            this.current = 0;
            this.question = this.allData[this.current].questionName;
            this.showAnsTime = false;
            this.showQuestionBank = true;
        },
        startTest() {
            startExam({
                courseId: this.data.courseId,
                projectId: this.data.projectId,
            }).then((res) => {
                console.log(res.data.code);
                this.$store.commit("asHead", false);
                if (res.data.code == 200) {
                    this.showStart = false;
                    this.showTest = true;
                    this.countDown();
                    this.startTime = new Date().valueOf();
                    this.saveInfo.examId = res.data.data;
                } else {
                    console.log(123);
                    this.$Message.warning(res.data.msg);
                }
            });
        },
        //进页面查询examId
        getData(data) {
            queryCloseExam(data).then((res) => {
                if (res.data !== null && res.data !== "" && res.data !== undefined) {
                    localStorage.setItem("examId", res.data);
                }
            });
        },
        countDown() {
            this.now = Date.parse(new Date());
            //时间差
            this.cha = this.end - this.now;
            this.timmer = setInterval(() => {
                this.cha -= 1000;
                //小时
                this.h = parseInt((this.cha / 1000 / 60 / 60) % 24);
                //分钟
                this.m = parseInt((this.cha / 1000 / 60) % 60);
                //秒钟
                this.s = parseInt((this.cha / 1000) % 60);
                this.h = this.h > 9 ? this.h : "0" + this.h;
                this.m = this.m > 9 ? this.m : "0" + this.m;
                this.s = this.s > 9 ? this.s : "0" + this.s;
                if (this.cha <= 1000 && this.cha > 0) {
                    this.h = "00";
                    this.m = "00";
                    this.s = "00";
                    this.$Modal.warning({
                        title: "考试结束!",
                        content: "答题时间到,考试结束!",
                    });
                    this.subTopicTime();
                    clearInterval(this.timmer);
                }
            }, 1000);
        },

        Get(name) {
            return Cookies.get(`admin-${name}`);
        },

        reload() {
            this.$router.replace({ path: "/courseList" });
        },

        //   查询题目
        async getExam() {
            let data = {
                courseId: this.data.courseId,
                projectId: this.data.projectId,
                examStatus: 1,
            };
            const res = await queryExamList(data);
            this.answerSize = res.data.data.answerSize;
            this.passNumber = res.data.data.passNumber;
            this.answerTime = res.data.data.answerTime;
            this.passAlso = res.data.data.passAlso;

            this.end = new Date().valueOf() + res.data.data.answerTime * 60 * 1000;

            this.allData = null;
            this.allData = res.data.data.answer;
            this.question = this.allData[this.current].questionName;
            this.anwArr();
            this.allData.forEach((item) => {
                if (item.type == 1) {
                    if (this.single.length >= this.allData.length) {
                        return;
                    } else {
                        this.single.push(item);
                    }
                } else if (item.type == 2) {
                    if (this.multiple.length >= this.allData.length) {
                        return;
                    } else {
                        this.multiple.push(item);
                    }
                } else if (item.type == 3) {
                    if (this.short.length >= this.allData.length) {
                        return;
                    } else {
                        this.short.push(item);
                    }
                }
            });
        },
        /**
         * 先遍历第一个data中的数据转为数组
         */
        //TODO:answer
        async anwArr() {
            let arr = [];
            let arrs = this.allData[0];
            for (let i = 0; i < 26; i++) {
                let code = "choice" + String.fromCharCode(65 + i);
                if (arrs[code] !== null && arrs[code] !== undefined && arrs[code] !== "") {
                    let o = {
                        option: arrs[code],
                        name: String.fromCharCode(65 + i),
                    };
                    arr.push(o);
                }
            }
            arrs.options = arr;
            await this.anwArrs();
        },
        /**
         * 再异步遍历所有数据 转为数组
         */
        async anwArrs() {
            await this.allData.forEach((element) => {
                let arr = [];
                for (let i = 0; i < 26; i++) {
                    let code = "choice" + String.fromCharCode(65 + i);
                    if (element[code] !== null && element[code] !== undefined && element[code] !== "") {
                        let o = {
                            option: element[code],
                            name: String.fromCharCode(65 + i),
                        };
                        arr.push(o);
                    }
                }
                element.options = arr;
                console.log(element.options);
            });
        },
        //TODO:下一题
        next() {
            let that = this;
            if (!this.TestCompleted) {
                // 每次下一题的时候给本题状态变为已做,再次点下一题的时候就不置空
                if (!this.allData[this.current].isOk) {
                    //单选题
                    if (this.current > this.allData.length) {
                        this.$Message.warning("已经是最后一题了哦!");
                    }
                    if (this.allData[this.current].type == 1) {
                        if (this.answer == "" || this.answer == null || this.answer == undefined) {
                            this.$Message.warning("请选择你的答案");
                            return;
                        }
                        if (
                            this.allData[this.current].userAnswer !== "" &&
                            this.allData.userAnswer !== null &&
                            this.allData.userAnswer !== undefined
                        ) {
                            this.anwArr = this.allData[this.current].userAnswer;
                        }
                        this.saveInfo.userAnswer = this.answer;
                        this.saveInfo.questionId = this.allData[this.current].id;
                        saveTopic(this.saveInfo).then((res) => {
                            if (res.data.code == 200) {
                                that.allData[that.current].userAnswer = that.answer;
                                that.$set(that.allData[this.current], "userAnswer", that.answer);
                                this.question = this.allData[this.current + 1].questionName;
                                this.answer = null;
                                this.allData[this.current].isOk = true;
                                this.current += 1;
                                this.$forceUpdate();
                            }
                        });
                    }
                    //多选题
                    if (this.allData[this.current].type == 2) {
                        if (this.answers && this.answers.length < 1) {
                            this.$Message.warning("请选择你的答案");
                            return;
                        }
                        this.answers = this.answers.sort();
                        this.saveInfo.userAnswer = this.answers.join(",");
                        this.saveInfo.questionId = this.allData[this.current].id;
                        saveTopic(this.saveInfo).then((res) => {
                            if (res.data.code == 200) {
                                this.question = this.allData[this.current + 1].questionName;
                                this.allData[this.current].userAnswer = this.answers.join(",");
                                this.answers = [];
                                this.allData[this.current].isOk = true;
                                this.current += 1;
                                this.$forceUpdate();
                            }
                        });
                    }
                    //简答题
                    if (this.allData[this.current].type == 3) {
                        if (this.anwserString == "" || this.anwserString == null || this.anwserString == undefined) {
                            this.$Message.warning("请填写你的答案");
                            return;
                        }
                        this.saveInfo.userAnswer = this.anwserString;
                        this.saveInfo.questionId = this.allData[this.current].id;
                        saveTopic(this.saveInfo).then((res) => {
                            if (res.data.code == 200) {
                                this.question = this.allData[this.current + 1].questionName;
                                this.anwserString = this.allData[this.current + 1].userAnswer;
                                this.allData[this.current].isOk = true;
                                this.current += 1;
                                this.$forceUpdate();
                            }
                        });
                    }
                } else {
                    if (that.allData[that.current + 1].type == 1) {
                        that.allData[that.current].userAnswer = that.answer;
                        if (!that.allData[that.current + 1].userAnswer) {
                            that.answer = null;
                        } else {
                            that.answer = that.allData[that.current + 1].userAnswer;
                        }
                    }
                    if (this.allData[this.current + 1].type == 2) {
                        if (that.allData[that.current + 1].userAnswer === null || that.allData[that.current + 1].userAnswer === undefined) {
                            that.answers = null;
                        } else {
                            if (
                                that.allData[that.current + 1] &&
                                that.allData[that.current + 1].userAnswer &&
                                Array.isArray(that.allData[that.current + 1].userAnswer)
                            ) {
                                that.answers = that.allData[that.current + 1].userAnswer.join(",");
                            } else if (
                                that.allData[that.current + 1] &&
                                that.allData[that.current + 1].userAnswer &&
                                !Array.isArray(that.allData[that.current + 1].userAnswer)
                            ) {
                                that.answers = that.allData[that.current + 1].userAnswer;
                            }
                        }
                    }
                    if (this.allData[this.current + 1].type == 3) {
                        that.allData[that.current].userAnswer = that.anwserString;
                        if (!that.allData[that.current + 1].userAnswer) {
                            that.anwserString = null;
                        } else {
                            that.anwserString = that.allData[that.current + 1].userAnswer;
                        }
                    }
                    this.current += 1;
                    this.question = this.allData[this.current].questionName;
                }
            } else {
                this.current += 1;
                this.question = this.allData[this.current].questionName;
                if (this.allData[this.current].type === 2) {
                    if (this.allData[this.current] && this.allData[this.current].answer && !Array.isArray(this.allData[this.current].answer)) {
                        let arrs = this.allData[this.current].userAnswer.split(",");
                        arrs.forEach((l) => {
                            this.allData[this.current].options.forEach((p) => {
                                console.error(l, p, this.allData[this.current])
                                if (this.allData[this.current].userAnswer.indexOf(p.name) != -1) {
                                    p.isAnswer = 1;
                                    p.isCorrect = this.allData[this.current].answer.indexOf(p.name) != -1;
                                }
                            });
                        });
                    }
                    if (
                        this.allData[this.current] &&
                        this.allData[this.current].userAnswer &&
                        !Array.isArray(this.allData[this.current].userAnswer)
                    ) {
                        this.answers = this.allData[this.current].userAnswer.split(",");
                    }
                }
                if (this.allData[this.current].type === 1) {
                    this.answer = this.allData[this.current].userAnswer;
                }
                console.log(this.allData);
                this.$forceUpdate();
            }
        },

        //上一步
        pre() {
            if (this.current < 1) {
                this.$Message.warning("已经是第一题了哦!");
                this.current = 0;
                return;
            }
            //单选题
            if (this.allData[this.current - 1].type == 1) {
                this.current -= 1;
                this.answer = this.allData[this.current].userAnswer;
            }

            //多选题
            if (this.current != 0 && this.allData[this.current - 1].type == 2) {
                this.current -= 1;

                if (this.allData[this.current] && this.allData[this.current].userAnswer && !Array.isArray(this.allData[this.current].userAnswer)) {
                    this.answers = this.allData[this.current].userAnswer.split(",");
                }

                if (this.allData[this.current] && this.allData[this.current].answer && !Array.isArray(this.allData[this.current].answer)) {
                    let arrs = this.allData[this.current].userAnswer.split(",");
                    arrs.forEach((l) => {
                        this.allData[this.current].options.forEach((p) => {
                            console.error(l, p, this.allData[this.current])
                            if (this.allData[this.current].userAnswer.indexOf(p.name) != -1) {
                                p.isAnswer = 1;
                                p.isCorrect = this.allData[this.current].answer.indexOf(p.name) != -1;
                            }
                        });
                    });
                    this.$forceUpdate();
                }
            }
            //问答题
            if (this.current != 0 && this.allData[this.current - 1].type == 3) {
                this.current -= 1;
                this.anwserString = this.allData[this.current].userAnswer;
            }
            this.question = this.allData[this.current].questionName;
        },

        //获取答题耗时
        getHours(timestamp) {
            let time = new Date(timestamp);
            const hours = time.getHours().toString().padStart(2, "0");
            const minute = time.getMinutes().toString().padStart(2, "0");
            const second = time.getSeconds().toString().padStart(2, "0");

            return minute + "分" + second + "秒";
        },
        examEnd() {
            if (!this.$store.state.headShow) {
                this.$Modal.confirm({
                    title: "提交试卷",
                    content: "点击确定提交试卷,提交后不可更改是否确认?",
                    onOk: () => {
                        this.$router.push("/courseList");
                    },
                });
            } else {
                this.$router.push("/courseList");
            }
        },
        //获取交卷时间
        getYMDHMS(timestamp) {
            let time = new Date(timestamp);
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let date = time.getDate();
            let hours = time.getHours();
            let minute = time.getMinutes();
            let second = time.getSeconds();

            if (month < 10) {
                month = "0" + month;
            }
            if (date < 10) {
                date = "0" + date;
            }
            if (hours < 10) {
                hours = "0" + hours;
            }
            if (minute < 10) {
                minute = "0" + minute;
            }
            if (second < 10) {
                second = "0" + second;
            }
            return year + "年" + month + "月" + date + "日" + "  " + hours + ":" + minute;
        },
        // 提交试卷  isPass 1 通过 2未通过 3待批阅
        subTopic() {
            this.subBtn = true;
            //结束时间
            this.successTime = new Date().valueOf();
            let time = this.getNowFormatDate();
            //提交时间=> 年月日格式
            this.subTime = minutes(time);
            //结束时间减去开始时间等于考试用时 => xx 时 xx 分 格式
            this.duration = this.getHours(this.successTime - this.startTime);
            // 先提交最后一题
            //单选题
            if (this.allData[this.current].type === 1) {
                saveTopic({
                    courseId: this.data.courseId,
                    examId: this.saveInfo.examId,
                    isValid: this.allData[this.current].isValid,
                    projectId: this.data.projectId,
                    questionId: this.allData[this.current].id,
                    score: this.allData[this.current].score,
                    userAnswer: this.answer ? this.answer : "",
                }).then((res) => {
                    if (res.data.code === 200) {
                        this.allData[this.current].userAnswer = this.answer;
                        this.saveInfo.userAnswer = this.answer;
                        this.allData[this.current].isOk = true;
                    }
                });
            }
            //多选题
            if (this.allData[this.current].type === 2) {
                console.log(this.answers, "answersanswersanswers");
                saveTopic({
                    courseId: this.data.courseId,
                    examId: this.saveInfo.examId,
                    isValid: this.allData[this.current].isValid,
                    projectId: this.data.projectId,
                    questionId: this.allData[this.current].id,
                    score: this.allData[this.current].score,
                    userAnswer: this.answers ? this.answers.join(",") : "",
                }).then((res) => {
                    if (res.data.code === 200) {
                        this.allData[this.current].userAnswer = this.answers.join(",");
                        this.allData[this.current].isOk = true;
                    }
                });
            }
            //问答题
            if (this.allData[this.current].type === 3) {
                saveTopic({
                    courseId: this.data.courseId,
                    examId: this.saveInfo.examId,
                    isValid: this.allData[this.current].isValid,
                    projectId: this.data.projectId,
                    questionId: this.allData[this.current].id,
                    score: this.allData[this.current].score,
                    userAnswer: this.anwserString ? this.anwserString : "",
                }).then((res) => {
                    if (res.data.code === 200) {
                        this.allData[this.current].userAnswer = this.anwserString;
                        this.allData[this.current].isOk = true;
                    }
                });
            }
            this.$Modal.confirm({
                title: "提交试卷",
                content: "点击确定提交试卷,提交后不可更改是否确认?",
                onOk: () => {
                    let arr = [];
                    this.allData.forEach((e) => {
                        let obj = {};
                        if (e.userAnswer && e.userAnswer !== undefined && e.userAnswer !== null && e.userAnswer !== "") {
                            obj.courseId = e.courseId;
                            obj.courseId = this.data.courseId;
                            obj.examId = this.saveInfo.examId;
                            obj.isValid = e.isValid;
                            obj.projectId = this.data.projectId;
                            obj.questionId = e.id;
                            obj.score = e.score;
                            obj.userAnswer = e.userAnswer;
                            arr.push(obj);
                        }
                    });
                    let p = localStorage.getItem("projectData");
                    let i = JSON.parse(p);
                    endExam({
                        courseId: this.data.courseId,
                        examId: this.saveInfo.examId,
                        projectId: this.data.projectId,
                        orderNo: i.orderNo,
                        list: arr,
                    }).then((res) => {
                        console.log(res);
                        if (res.data.code == 200) {
                            console.log(this.allData);
                            this.$Message.success("提交成功");
                            this.result = res.data.data.isPass;
                            this.showTest = false;
                            console.log(this.result, "result");
                            this.passAlso = res.data.data.residue;
                            this.TestCompleted = true;
                            this.$forceUpdate();
                            if (this.result !== 3) {
                                this.right = res.data.data.right;
                                if (this.result == 1) {
                                    this.gameOver = res.data.data.gameOver;
                                    if (this.gameOver) {
                                        this.$Notice.success({
                                            title: "恭喜你",
                                            desc: "你已完成培训，执业药师（含从业药师）和药学初、中、高级专业技术人员学习完成5个工作日后前往浙江药师网查询，其他项目可在“学时查询”中打印成绩",
                                        });
                                    }
                                }
                                this.err = res.data.data.error;
                            }
                        }
                    });
                    console.error(this.multiple, this.single, "multiplemultiplemultiple");
                },
            });
        },

        //获取当前标准时间
        getNowFormatDate() {
            let date = new Date();
            var year = date.getFullYear() - 1;
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            let time = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
            return time;
        },

        // 时间倒计时触发  isPass 1 通过 2未通过 3待批阅
        subTopicTime() {
            this.subBtn = true;
            //结束时间
            this.successTime = new Date().valueOf();
            let stime = this.getNowFormatDate();
            //提交时间=> 年月日格式
            this.subTime = minutes(stime);
            //结束时间减去开始时间等于考试用时 => xx 时 xx 分 格式
            this.duration = this.getHours(this.successTime - this.startTime);
            // 先提交最后一题
            //单选题
            if (this.allData[this.current].type === 1) {
                console.log(this.answer);
                if (this.answer == "" && this.answer == null && this.answer === undefined) {
                    this.$Message.warning("请选择你的答案");
                    return;
                }
                saveTopic({
                    courseId: this.data.courseId,
                    examId: this.saveInfo.examId,
                    isValid: this.allData[this.current].isValid,
                    projectId: this.data.projectId,
                    questionId: this.allData[this.current].id,
                    score: this.allData[this.current].score,
                    userAnswer: this.answer,
                }).then((res) => {
                    if (res.data.code === 200) {
                        this.allData[this.current].userAnswer = this.answer;
                        this.allData[this.current].isOk = true;
                        this.answer = null;
                    }
                });
            }
            //多选题
            if (this.allData[this.current].type === 2) {
                console.log("222");
                if (this.answers && this.answers.length < 1) {
                    this.$Message.warning("请选择你的答案");
                    return;
                }
                saveTopic({
                    courseId: this.data.courseId,
                    examId: this.saveInfo.examId,
                    isValid: this.allData[this.current].isValid,
                    projectId: this.data.projectId,
                    questionId: this.allData[this.current].id,
                    score: this.allData[this.current].score,
                    userAnswer: this.anwsers.join(","),
                }).then((res) => {
                    if (res.data.code === 200) {
                        this.allData[this.current].userAnswer = this.anwsers.join(",");
                        this.allData[this.current].isOk = true;
                        this.anwsers = [];
                    }
                });
            }
            //问答题
            if (this.allData[this.current].type === 3) {
                console.log("333");
                if (this.anwserString == "" && this.anwserString == null && this.anwserString == undefined) {
                    this.$Message.warning("请输入你的答案");
                    return;
                }
                saveTopic({
                    courseId: this.data.courseId,
                    examId: this.saveInfo.examId,
                    isValid: this.allData[this.current].isValid,
                    projectId: this.data.projectId,
                    questionId: this.allData[this.current].id,
                    score: this.allData[this.current].score,
                    userAnswer: this.anwserString,
                }).then((res) => {
                    if (res.data.code === 200) {
                        this.allData[this.current].userAnswer = this.anwserString;
                        this.allData[this.current].isOk = true;
                        this.anwserString = "";
                    }
                });
            }
            let arr = [];
            if (this.allData && this.allData.length < 1) {
                let p = localStorage.getItem("projectData");
                let i = JSON.parse(p);
                endExam({
                    courseId: this.data.courseId,
                    examId: this.saveInfo.examId,
                    projectId: this.data.projectId,
                    orderNo: i.orderNo,
                    list: arr,
                }).then((res) => {
                    console.log(res);
                    if (res.data.code == 200) {
                        console.log(this.allData);
                        this.$Message.success("提交成功");
                        this.result = res.data.data.isPass;
                        this.showTest = false;
                        console.log(this.result, "result");
                        this.passAlso = res.data.data.residue;
                        this.TestCompleted = true;
                        this.$forceUpdate();
                        if (this.result !== 3) {
                            this.right = 0;
                            this.err = 0;
                        }
                    }
                });
                return;
            }
            this.allData.forEach((e) => {
                let obj = {};
                if (e.userAnswer && e.userAnswer !== undefined && e.userAnswer !== null && e.userAnswer !== "") {
                    obj.courseId = e.courseId;
                    obj.courseId = this.data.courseId;
                    obj.examId = this.saveInfo.examId;
                    obj.isValid = e.isValid;
                    obj.projectId = this.data.projectId;
                    obj.questionId = e.id;
                    obj.score = e.score;
                    obj.userAnswer = e.userAnswer;
                    arr.push(obj);
                }
            });

            let p = localStorage.getItem("projectData");
            let i = JSON.parse(p);
            endExam({
                courseId: this.data.courseId,
                examId: this.saveInfo.examId,
                projectId: this.data.projectId,
                orderNo: i.orderNo,
                list: arr,
            }).then((res) => {
                console.log(res);
                if (res.data.code == 200) {
                    console.log(this.allData);
                    this.$Message.success("提交成功");
                    this.result = res.data.data.isPass;
                    this.showTest = false;
                    console.log(this.result, "result");
                    this.passAlso = res.data.data.residue;
                    this.TestCompleted = true;
                    this.$forceUpdate();
                    if (this.result !== 3) {
                        this.right = res.data.data.right;
                        this.err = res.data.data.error;
                    }
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
.content {
    width: 1200px;
    margin: 0 auto;
    border: none;
    color: #000;
    .main {
        height: 100%;
        .anwserBox {
            width: 100%;
            .titleBox {
                padding: 0 15px;
                line-height: 48px;
                color: #fff;
                width: 100%;
                height: 48px;
                background-color: rgba(0, 0, 0, 0.8);
                .spanImg {
                    width: 51px;
                    height: 23px;
                    line-height: 20px;
                    margin-top: 10px;
                    position: relative;
                    top: 5px;
                }
                .span3 {
                    .spanImg {
                        width: 51px;
                        height: 23px;
                        line-height: 20px;
                    }
                    text-align: center;
                    width: 54px;
                    height: 23px;
                }
                span {
                    font-size: 16px;
                    margin: 0;
                    color: #fff;
                    margin-right: 40px;
                }
            }
            .right {
                height: 1200px;
                background-color: #f8faff;
                padding: 15px 15px 0 80px;
                .submit {
                    background: #3562e8;
                    width: 246px;
                    height: 40px;
                    color: #fff;
                }
                .options {
                    float: left;
                    width: 30px;
                    height: 30px;
                    user-select: none;
                    margin-bottom: 18px;
                    border-radius: 4px;
                    border: 1px solid #333;
                    color: #333;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .multipleBox {
                    width: 260px;
                    display: flex;
                    margin-top: 14px;
                    :not(:last-child) {
                        margin-right: 20px;
                    }
                }
                .singleBox {
                    width: 260px;
                    display: flex;
                    margin-top: 14px;
                    flex-wrap: wrap;
                    :not(:last-child) {
                        margin-right: 20px;
                    }
                }
                .optionsActive {
                    float: left;
                    width: 30px;
                    height: 30px;
                    user-select: none;
                    margin-bottom: 18px;
                    border-radius: 4px;
                    border: 1px solid #3562e8;
                    color: #3562e8;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .userActive {
                    float: left;
                    width: 30px;
                    height: 30px;
                    user-select: none;
                    margin-bottom: 18px;
                    border-radius: 4px;
                    border: 1px solid #3562e8;
                    color: #3562e8;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .shortBox {
                    width: 260px;
                    display: flex;
                    margin-top: 14px;
                    :not(:last-child) {
                        margin-right: 20px;
                    }
                }
                .title {
                    font-size: 16px;
                    font-weight: bold;
                    color: #333;
                    margin-bottom: 24px;
                }
            }
            .content {
                padding: 50px 50px 0 0px;
                position: relative;
                text-align: center;
                //   display: flex;
                justify-content: center;
                height: 600px;
                width: 600px;
                .text {
                    display: inline-block;
                    word-wrap: break-word;
                }
                .buttonBox {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    margin-top: 20px;
                }
            }
        }
    }
    // TODO:刚开始进入页面的样式
    .create {
        height: 100%;
        padding-top: 150px;
        padding-bottom: 165px;
        text-align: center;
        .courseInfo {
            margin-top: 60px;
            margin: 0 auto;
            margin: 60px 0 65px 0;
            div {
                font-size: 16px;
                font-weight: 500;
                margin-top: 20px;
            }
        }
    }
    //TODO:成功页面样式
    .success {
        height: 100%;
        padding-top: 60px;
        padding-bottom: 40px;
        text-align: center;
        width: 100%;
        min-width: 1200px;
        img {
            width: 247px;
            height: 182px;
            margin: 60px 0 50px 0;
        }
    }
    // TODO:等待批阅页面样式
    .wait {
        height: 100%;
        padding-top: 60px;
        padding-bottom: 40px;
        text-align: center;
        width: 100%;
        min-width: 1200px;
        img {
            width: 247px;
            height: 182px;
            margin: 60px 0 30px 0;
        }
    }
    // TODO:失败页面样式
    .error {
        height: 100%;
        padding-top: 60px;
        padding-bottom: 40px;
        text-align: center;
        width: 100%;
        min-width: 1200px;
        img {
            width: 247px;
            height: 182px;
            margin: 60px 0 30px 0;
        }
    }
}
/deep/.ivu-radio-group {
    width: 60%;
    margin: 0 auto;
    label {
        display: block;
        margin-top: 30px;
    }
    .ivu-radio-wrapper {
        white-space: inherit;
        width: 650px;
    }
}
/deep/.ivu-checkbox-group {
    width: 60%;
    margin: 0 auto;
    label {
        display: block;
        margin-top: 30px;
    }
    .ivu-radio-wrapper {
        white-space: inherit;
        width: 650px;
    }
}
.answerGreen {
    border: 1px solid #00a21a !important;
    background-color: #fff;
    color: #00a21a !important;
}
.answerRed {
    border: 1px solid #db1829 !important;
    background-color: #fff;
    color: #db1829 !important;
}
.answerAffirm,
.errorAnswer {
    color: #FF0000;
    /deep/.ivu-radio::after {
        position: absolute;
        width: 11px;
        height: 11px;
        left: 2.5px;
        top: 3px;
        border-radius: 50%;
        display: table;
        border-top: 0;
        border-left: 0;
        content: " ";
        background-color: #FF0000 !important;
    }

    /deep/.van-checkbox__icon .van-icon {
        background: #FF0000 !important;
    }
    /deep/.ivu-checkbox-disabled .ivu-checkbox-inner:after {
        border-color: #FF0000 !important;
    }
    /deep/.ivu-checkbox-inner:after {
        // content: "";
        // display: table;
        // width: 0.02083rem;
        // height: 0.04167rem;
        // position: absolute;
        // top: 0.01042rem;
        // left: 0.02604rem;
        // border: 0.01042rem solid #fff;
        // border-top: 0;
        // border-left: 0;
        // -webkit-transform: rotate(45deg) scale(1);
        // -ms-transform: rotate(45deg) scale(1);
        // transform: rotate(45deg) scale(1);
        // -webkit-transition: all 0.2s ease-in-out;
        // transition: all 0.2s ease-in-out;
    }
    /deep/.ivu-checkbox-checked .ivu-checkbox-inner:after {
        content: " ";
        // display: table;
        // width: 0.02083rem;
        // height: 0.04167rem;
        // position: absolute;
        // top: 0.01042rem;
        // left: 0.02604rem;
        border-color: red;
        // border-top: 0;
        // border-left: 0;
        // -webkit-transform: rotate(45deg) scale(1);
        // -ms-transform: rotate(45deg) scale(1);
        // transform: rotate(45deg) scale(1);
        // -webkit-transition: all 0.2s ease-in-out;
        // transition: all 0.2s ease-in-out;
    }
}
.answerAffirm{
    color: #00a21a;
    /deep/.ivu-radio::after {
        background-color: #00a21a !important;
    }
    /deep/.van-checkbox__icon .van-icon {
        background-color: #00a21a !important;
    }
    /deep/.ivu-checkbox-disabled .ivu-checkbox-inner:after {
        border-color: #00a21a !important;
    }
     /deep/.ivu-checkbox-inner:after {
        border-color: #00a21a !important;
     }
}
.errDatas {
    /deep/.ivu-radio::after {
        position: absolute;
        width: 11px;
        height: 11px;
        left: 2.5px;
        top: 3px;
        border-radius: 50%;
        display: table;
        border-top: 0;
        border-left: 0;
        content: " ";
        background-color: #db1829;
    }
}
/deep/.ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner:after {
    border-color: #3562e8;
}
/deep/.ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #dcdee2;
}
/deep/.ivu-radio-disabled .ivu-radio-inner {
}
.question {
    text-align: left;
}
</style>